export const isTouch = () => {
    return "ontouchstart" in document.documentElement;
}
